import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { Link, useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import { notifyError } from "../../../helpers/helpers";
import {
  otpVerification,
  registerPhoneNumber,
} from "../../../redux/action/auth";

function OtpVerification() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const otp_ref = useRef();
  const [otpValue, setOtpValue] = useState("");
  const isLaptop = useMediaQuery({ query: "(max-width: 1400px)" });
  const [countdown, setCountdown] = useState(60);
  const [isResendDisabled, setIsResendDisabled] = useState(true);
  const { loading } = useSelector((state) => state?.loading);
  const { sessionId, phoneNumber } = useSelector(
    (state) => state?.newRegisterUser
  );

  const handleOtpValue = (e) => {
    e.preventDefault();
    if (otpValue.length !== 6) {
      return notifyError("OTP must be 6 characters long.");
    } else if (!sessionId?.session || !phoneNumber) {
      return notifyError("Request OTP again");
    }

    dispatch(otpVerification(phoneNumber, otpValue, sessionId, navigate));
  };

  const resendOtp = (e) => {
    e.preventDefault();
    dispatch(registerPhoneNumber({ phoneNumber }, navigate)).then(() => {
      setIsResendDisabled(true);
      setCountdown(60);
      setOtpValue("");
    });
  };

  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);
    } else if (countdown === 0) {
      setIsResendDisabled(false);
    }
    return () => clearInterval(timer);
  }, [countdown]);

  useEffect(() => {
    otp_ref.current?.focus();
    if (phoneNumber === "") {
      navigate(-1);
    }
  }, [phoneNumber, navigate]);

  return (
    <div className="auth-from slide-in" style={{ width: isLaptop && "700px" }}>
      <div>
        <div className="flex justify-center ">
          <img
            src="/images/auction-image.png"
            alt="logo"
            className="auction-logo"
          />
        </div>

        <h4 className="margin-0px text-center">Sign Up To Auction System</h4>
        <div className="purple lighten-5 cercle-purple-text p-1 flex mt-1">
          <i className="material-symbols-outlined">info</i>

          <p className="ml-1">
            This is a private access only. This dashboard is only for{" "}
            <b>Authorized Accounts</b>. Anyone interested in participating in
            the auction is welcome to sign up.
          </p>
        </div>

        <div className="mt-1">
          <form className="mt-1 " onSubmit={handleOtpValue}>
            <div className="input-field-style">
              <span className="material-symbols-outlined primary ">phone</span>
              <input
                className="browser-default input-field "
                disabled={true}
                type="number"
                value={phoneNumber}
                required
              />
              <p
                className="pointer cercle-purple-text"
                onClick={() => navigate(-1)}
              >
                Edit
              </p>
            </div>
            <div className="input-field-style">
              <span className="material-symbols-outlined primary ">lock</span>
              <input
                ref={otp_ref}
                className="browser-default input-field "
                placeholder="Enter OTP Sent to Your Phone Number"
                type="number"
                min={0}
                onChange={(e) => setOtpValue(e.target.value)}
                value={otpValue}
                required
              />
            </div>
            <div className="flex justify-end" style={{ marginTop: "5px" }}>
              {!countdown > 0 && (
                <button
                  className="pointer hover_otp blue-text"
                  onClick={resendOtp}
                  disabled={isResendDisabled}
                  type="button"
                >
                  Resend OTP
                </button>
              )}
              {countdown > 0 && <span>Resend otp in {countdown} seconds</span>}
            </div>

            <div className="submit-btn mv-2 column flex align-center ">
              <button
                className="btn full-width mb-1 mt-1 "
                type="submit"
                disabled={!otpValue || loading}
              >
                {loading ? <ClipLoader color="#fff" size={20} /> : "Next"}
              </button>
            </div>
          </form>
        </div>

        <div className="">
          <p className="semi-bold">
            Already a member?{" "}
            <Link to="/login">
              <span className="primary pointer">Log In</span>
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default OtpVerification;
